<script setup>
import i18n from "@/i18n"
import { toRefs, defineProps, defineEmits, watch, ref, computed, inject } from "vue";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import { getLangValue } from "@/utils/common"; //获取后端语言
const props = defineProps({
    compositionStructureList: {
        type: Array,
        required: true,
        default: () => []
    },
    menuList: {
        type: Array,
        required: true,
        default: () => []
    },
    // pageOptionList:{
    //     type: Array,
    //     required: true,
    //     default: () => []
    // },
    // currentPageList:{
    //     type: Array,
    //     required: true,
    //     default: () => []
    // },
})
const route = useRoute()
const showType = inject('showType')
const publicList = [
    {
        label: getLangValue('product-management', "notpublic"),
        value: 1
    },
    {
        label: getLangValue('product-management', "Opasc"),
        value: 3
    },
    {
        label: getLangValue('product-management', "completelypublic"),
        value: 2
    }
] // 公开类型
const emits = defineEmits(["update:compositionStructureList", "getDataList"])
const { compositionStructureList, } = toRefs(props)
const currentPageList = ref([]) // 分页
const pageOptionList = ref([]) // 分页信息
// const supplyChainList = ref([])
// const menuList = ref([])
// const getTemplateMenu = async () => {
//     const resp = await getProductTemplateMenu();
//     if (resp) {
//         menuList.value = resp.payload
//     }
// }
const supplyChainList = inject("supplyChainList") // 供应商list
//删除表格数据
const deleteTableList = (index, d_index) => {
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            compositionStructureList.value[index].tableList.splice(d_index, 1)
            // 判断如果只有一条 就显示内衬
            if (compositionStructureList.value[index].tableList.length == 1) {
                compositionStructureList.value[index].tableList[0].value2 = 'lining';
            }
            // 通知父组件修改数据
            emits('update:compositionStructureList', compositionStructureList.value)
        }
    });

}
const changeProduct = (index) => {
    // 文本修改
    currentPageList.value[index].currentPage = 1;
    emits('update:compositionStructureList', compositionStructureList.value)
    emits('getDataList', index, 1)
}

//添加表格数据
const addTableList = (index, data) => {
    console.log(compositionStructureList.value[index]);
    console.log(data);
    if (compositionStructureList.value[index].tableList.length == 0) {
        if (showType.value && compositionStructureList.value[index]?.extra?.template_type == 2 || data?.database_template_type == 2 || data.database_template_type == 1) {
            data.value2 = 'lining'; // 如果是一条数据默认是内衬数据
        }else{
            data.value2 = '';
        }
    } else {
        data.value2 = '';
    }
    let data1 = { ...data }
    compositionStructureList.value[index].tableList.push(data1)
    console.log(data);
    emits('update:compositionStructureList', compositionStructureList.value)
}

//检测是否可以添加
const checkData = (index, data) => {
    let data1 = { ...data }
    let arr = compositionStructureList.value[index].tableList.filter(item => item.database_id == data1.database_id)
    return !arr.length
}

const setPages = (d_index, total) => {
    // 设置分页
    if (!pageOptionList.value[d_index]) {
        pageOptionList.value[d_index] = { pageOption: [] }
    }
    // console.log(total);
    // console.log(d_index);
    pageOptionList.value[d_index].pageOption = [];
    let numberOfPages = Math.ceil(total / 10);

    if (numberOfPages == 0) {
        pageOptionList.value[d_index].pageOption.push(1);
    } else {
        for (let index = 1; index <= numberOfPages; index++) {
            pageOptionList.value[d_index].pageOption.push(index);
        }
    }

    // console.log(pageOptionList.value);
}
// const getHscodeName = (id) => {
//     return menuList.value.filter(item => item.id == id).length ? menuList.value.filter(item => item.id == id)[0].name : ""
// }

const currentPageListStr = computed(() => JSON.stringify(currentPageList.value))
const getPublic = (type) => {
    // 获取公开类型名称
    let arr = publicList.filter(item => item.value === type)
    if (arr.length) {
        return arr[0].label
    }
    return ''
}

// const isDecimal = (num) => {
//     // 是否整数
//     return /^\d+(\.\d+)?$/.test(num.toString());
// }
// const isDecimalWithTwoPlaces=(num)=> {
//     // 是否保留2位的小数
//   return /^\d+(\.\d{1,2})?$/.test(num.toString());
// }

const checkNumber = (num) => {
    // 检查是否是小数并且保留小数位不超过2位
    const decimalPlaces = num.toString().split('.')[1]?.length || 0;
    if (decimalPlaces > 2) {
        return true
    }
    return false

}


const blurValue = (index, d_index) => {
    // 比例输入后事件
    let value = compositionStructureList.value[index].tableList[d_index].value3
    if (value < 0) {
        compositionStructureList.value[index].tableList[d_index].value3 = 0
    } else {
        if (checkNumber(value)) {
            compositionStructureList.value[index].tableList[d_index].value3 = value.toFixed(2)
        }
    }
}

watch(compositionStructureList, (val) => {
    // 设置分页
    // console.log('1dwq',val);
    if (val.length > 0) {
        // if(currentPageList.value.length == 0){}
        // currentPageList.value = [];
        for (let k in val) {
            if (currentPageList.value.length < val.length) {
                currentPageList.value.push({ currentPage: 1, })
            }
            setPages(k, val[k].total)
        }
        // console.log(currentPageList.value);
    } else {
        currentPageList.value = [];
    }

}, { deep: true })

watch(currentPageListStr, (val, old) => {
    // 分页切换
    let val1 = JSON.parse(val)
    let old1 = JSON.parse(old)
    // console.log(val1);
    // console.log(old1);
    for (let k in val1) {
        if (old1[k] && (val1[k].currentPage != old1[k].currentPage)) {
            emits('getDataList', k, val1[k].currentPage)
            break;
        }
    }
}, { deep: true })

</script>
<template>

    <b-card v-if="compositionStructureList.length">
        <div class="row gy-3 w-100">
            <!-- <div class="d-flex justify-content-between align-items-center " style="font-weight: 500; font-size: 16px;">
                <div>
                    {{ getLangValue('product-template', "compositionStructure") }}
                </div>
            </div> -->
            <div v-for="(item, index) in compositionStructureList" :key="index" class="p-0"
                :id="`compositionStructure${index}`">
                <div class="d-flex justify-content-between align-items-center "
                    style="font-weight: 500; font-size: 16px;">
                    <div>
                        <span class="text-danger" v-if="item.required">*</span>
                        {{ i18n.global.locale == 'en' ? item.name_en : item.name }}
                        <span class="ms-2 text-danger" style="font-size: 12px;">{{ getLangValue('product-management',
                            "weight_rate_info") }}</span>
                    </div>
                </div>
                <div class="d-flex justify-content-sm-start py-2 px-4"
                    style="border-bottom: 1px solid #E9EBEC; border-top: 1px solid #E9EBEC;">
                    <div class="search-box ms-2" style="font-weight: 500; font-size: 16px;">
                        <!-- {{ item.value ? getHscodeName(item.value) : '' }} -->

                        {{ i18n.global.locale == 'en' ? item.p_name_en : item.p_name }}
                    </div>
                </div>
                <div class="">
                    <!-- 显示表格 -->
                    <div class="px-4 py-2" style="border-bottom: 1px dashed rgba(233, 235, 236, 1);">
                        <div class="d-flex">
                            <div style="width: 100px;">{{ getLangValue('product-template', "number") }}</div>
                            <div class="mx-2" style="flex: 2; max-width: 400px;">{{ getLangValue('product-management',
                                "pid") }}</div>
                            <div class="mx-2" style="flex: 2; max-width: 400px;">{{ getLangValue("attribute.name") }}
                            </div>
                            <div class="flex-1 mx-2"
                                v-if="showType && (item.extra?.template_type == 2 || item.tableData.filter(item => item.database_template_type == 2 || item.database_template_type == 1).length)">
                                {{ getLangValue('product-template', "structure") }}
                            </div>
                            <div class="flex-1 mx-2">{{ getLangValue('product-template', "proportion") }}</div>
                        </div>
                        <div class="d-flex" v-for="(data, d_index) in item.tableList" :key="d_index">
                            <div style="width: 100px;" class=" py-2 d-flex align-items-center">{{ d_index + 1 }}</div>
                            <div class="flex-2 py-2 mx-2 d-flex align-items-center"
                                style="flex:2; max-width: 400px; word-break: break-all; white-space: normal;text-overflow: ellipsis;">
                                {{ data.pid || data.database_id }}
                            </div>
                            <div class="flex-2 py-2 mx-2 d-flex align-items-center" style="flex:2;max-width: 400px;">
                                {{ data.name }}
                            </div>
                            <div class="flex-1 py-2 mx-2"
                                v-if="showType && (item.extra?.template_type == 2 || item.tableData.filter(item => item.database_template_type == 2 || item.database_template_type == 1).length)">
                                <!-- <input clearable class="form-control" v-model="data.value2" required
                                    :disabled="route.query.type == 'view'" /> -->
                                <el-select v-model="data.value2" placeholder=" " size="large" style="width: 100%;"
                                    clearable :disabled="route.query.type == 'view' || item.tableList.length == 1">
                                    <el-option :label="getLangValue('attribute.shell')" value="shell" />
                                    <el-option :label="getLangValue('attribute.interlayer')" value="interlayer" />
                                    <el-option :label="getLangValue('attribute.lining')" value="lining" />
                                </el-select>
                            </div>
                            <div class="flex-1 py-2 mx-2 d-flex align-items-center">
                                <div class="flex-1">
                                    <input @blur="blurValue(index, d_index)" type="number" clearable
                                        class="form-control" v-model="data.value3" required
                                        :disabled="route.query.type == 'view'" />
                                </div>
                                <i @click="deleteTableList(index, d_index)" v-if="route.query.type != 'view'"
                                    class="ri-delete-bin-5-fill me-1 align-bottom mx-2 cursor-pointer"
                                    style="color: red;"></i>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-end my-3">
                        <!-- //产品名称 -->
                        <div class="search-box ms-2">
                            <input v-model="item.inputVal" type="text" class="form-control"
                                :disabled="route.query.type == 'view'"
                                :placeholder="getLangValue('product-template.searchProducts')"
                                @change="changeProduct(index)" />
                            <i class="ri-search-line search-icon"></i>
                        </div>
                        <!-- 供应链 -->
                        <el-select @change="changeProduct(index)" class="mx-2" v-model="item.inputVal1" filterable
                            :placeholder="getLangValue('my.supply-chain', 'name')" multiple collapse-tags size="large"
                            style="width: 200px; height: 37.5px;" clearable :disabled="route.query.type == 'view'">
                            <el-option v-for="item1 in supplyChainList" :key="item1.id" :label="item1.name"
                                :value="item1.id">
                            </el-option>
                        </el-select>
                        <!-- 数据公开类型 -->
                        <el-select @change="changeProduct(index)" v-model="item.inputVal2" filterable
                            :placeholder="getLangValue('attribute.dataPublicType')" size="large"
                            style="width: 200px; height: 37.5px;" clearable :disabled="route.query.type == 'view'">
                            <el-option v-for="item1 in publicList" :key="item1.value" :label="item1.label"
                                :value="item1.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="py-2">
                        <div class="d-flex px-4 py-2" style="background-color: rgba(246, 248, 251, 1);">
                            <div style="width: 350px;">{{ getLangValue('product-management', "pid") }}</div>
                            <div class="mx-2" style="width: 300px;">{{ getLangValue("attribute.name") }}</div>
                            <div class="flex-1 mx-2">{{ getLangValue('product-template', "publicType") }}</div>
                            <div class="flex-1 mx-2">{{ getLangValue('product-template', "type") }}</div>
                            <div class="flex-1 mx-2">{{ getLangValue('product-template', "price") }}</div>
                            <div class="flex-1 mx-2">{{ getLangValue('product-template', "size") }}</div>
                            <div class="flex-1 mx-2">{{ getLangValue('product-template', "color") }}</div>
                        </div>
                        <div class="d-flex px-4 align-item-center" v-for="(data, d_index) in item.tableData"
                            :key="d_index" style="min-height: 52px;">
                            <div style="width: 350px;color: rgba(118, 131, 139, 1); word-break: break-all; white-space: normal; word-wrap: break-word; white-space: normal;text-overflow: ellipsis; "
                                class="py-2 d-flex align-items-center">{{ data.pid || data.database_id
                                }}</div>
                            <div class="py-2 mx-2 d-flex align-items-center"
                                style="width: 300px; word-break: break-all; white-space: normal; word-wrap: break-word; white-space: normal;text-overflow: ellipsis;">
                                {{ data['name'] }}
                            </div>
                            <div class="flex-1 py-2 mx-2 d-flex align-items-center">
                                {{ getPublic(data.public_type) }}
                            </div>
                            <div class="flex-1 py-2 mx-2 d-flex align-items-center">
                                {{ data['type'] }}
                            </div>
                            <div class="flex-1 py-2 mx-2 d-flex align-items-center">
                                {{ data['price'] }}
                            </div>
                            <div class="flex-1 py-2 mx-2 d-flex align-items-center">
                                {{ data['size'] }}
                            </div>
                            <div class="flex-1 py-2 mx-2 d-flex align-items-center">
                                <div class="flex-1">
                                    {{ data['color'] }}
                                </div>
                                <i @click="addTableList(index, data)"
                                    v-if="route.query.type != 'view' && checkData(index, data)"
                                    class="ri-add-circle-fill me-1 align-bottom mx-2 cursor-pointer"
                                    style="color: rgba(118, 131, 139, 1); font-size: 24px;"></i>
                            </div>
                        </div>
                        <!-- 分页 -->
                        <Pagination v-if="item.total && currentPageList.length"
                            v-model:page="currentPageList[index].currentPage" :pages="pageOptionList[index].pageOption"
                            :showPageSelect="false" :showJump="false" :tab_info_length="item.total" class="me-5 my-3">
                        </Pagination>
                    </div>
                </div>
            </div>
        </div>
    </b-card>
</template>
<style scoped>
:deep(.el-select__wrapper) {
    height: 100%;
}
</style>